import { useCallback, useEffect, useState } from 'react';

// Alterações do Agente do Seller esperando aprovação (do chat ou de chave MCP), por conversa.
// Alimenta o número no menu "Agente" e o bloco da tela Hoje.
export const PENDING_CHANGED_EVENT = 'seller-agent-pending-changed';

export interface PendingSession { id: string; title: string; source: string; pending: number }

function headers() {
  const token = localStorage.getItem('auth_token');
  return { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) };
}

export function useSellerAgentPending(enabled: boolean) {
  const [total, setTotal] = useState(0);
  const [sessions, setSessions] = useState<PendingSession[]>([]);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      const res = await fetch('/api/seller/agent/pending', { headers: headers() });
      const json = await res.json();
      if (json?.success) { setTotal(json.data?.total || 0); setSessions(json.data?.sessions || []); }
    } catch {
      // Aviso é informativo: falha de rede não atrapalha a tela.
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return;
    refresh();
    const t = window.setInterval(() => { if (document.visibilityState === 'visible') refresh(); }, 60000);
    const onFocus = () => refresh();
    window.addEventListener('focus', onFocus);
    // Aprovou/recusou na tela do Agente: atualiza o número na hora.
    window.addEventListener(PENDING_CHANGED_EVENT, onFocus);
    return () => { window.clearInterval(t); window.removeEventListener('focus', onFocus); window.removeEventListener(PENDING_CHANGED_EVENT, onFocus); };
  }, [enabled, refresh]);

  return { total, sessions, refresh };
}
